import React, { useEffect, useState } from 'react';
import { Card, Button, Tag } from 'antd';
import { ClockCircleOutlined, MailOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '@/features/auth/AuthContext.jsx';
import { data_from_server_post } from '@/shared/http/client';
const Section = ({ children, style }) => (
    <div style={{ marginTop: 16, ...style }}>{children}</div>
);

const DetailRow = ({ label, value, addon }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ color: '#8c8c8c', fontWeight: 300 }}>{label}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ color: '#111827', fontWeight: 300 }}>{value}</div>
            {addon}
        </div>
    </div>
);

const Bullet = ({ children }) => (
    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginTop: 8 }}>
        <span style={{ display: 'inline-block', width: 6, height: 6, background: '#4096ff', borderRadius: 6, marginTop: 8 }} />
        <div style={{ color: '#4b5563' }}>{children}</div>
    </div>
);

const HelpBox = ({ email }) => (
    <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 10, background: '#f5f5f5', display: 'flex', justifyContent: 'center', border: "1px solid #d9d9d9", marginTop: "28px" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, justifyContent: "center" }}>
            <MailOutlined style={{ color: "#1777ff" }} />
            <div style={{ fontWeight: 400 }}>Need help?</div>
        </div>
        <div style={{ color: '#8c8c8c', fontWeight: 300 }}>
            Contact your administrator at{' '}
            <a href={`mailto:${email}`} style={{ color: '#1677ff' }}>{email}</a>
        </div>
    </Card>
);

export default function PendingApproval() {
    const { user, logout } = useAuth();
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        data_from_server_post('users/admins', {}, (res) => {
            setAdmins(res?.admins || []);
        });
    }, []);

    const userName = user?.name || '';
    const userEmail = user?.email || '';

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 30, flexDirection: 'column' }}>
            <Card style={{ width: 448, borderRadius: 12, border: "1px solid #D9D9D9" }} bodyStyle={{ padding: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
                    <div style={{ width: 46, height: 46, borderRadius: 56, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ClockCircleOutlined style={{ color: '#1677ff', fontSize: 22 }} />
                    </div>
                </div>
                <div style={{ textAlign: 'center', fontSize: 28, fontWeight: 500, marginTop: 18 }}>Account Pending</div>
                <div style={{ textAlign: 'center', fontSize: 28, fontWeight: 500, marginTop: -5 }}>Approval</div>
                <div style={{ color: '#8c8c8c', textAlign: 'center', marginTop: 12, fontWeight: 300 }}>
                    Hi {userName}, your account has been created successfully. An administrator needs to approve your access before you can start using Specific AI.
                </div>

                <Section>
                    <div style={{ backgroundColor: '#f5f5f5', padding: 12, borderRadius: 8 }}>
                        <DetailRow label="Email:" value={userEmail || 'shani@optune.ai'} />
                        <div style={{ height: 10 }} />
                        <DetailRow label="Status:" value="" addon={<Tag color="#ebebeb" style={{ color: '#9b9b9b', border: '1px solid #d9d9d9', paddingTop: 3, paddingBottom: 3, paddingLeft: 8, paddingRight: 8, margin: 0 }}>Pending</Tag>} />
                    </div>
                </Section>

                <Section>
                    <div style={{ fontWeight: 600, marginTop: 28 }}>What happens next?</div>
                    <Bullet><span style={{ color: "#9a9a9a", fontWeight: 300, fontSize: 14 }}>You'll receive an email notification once your account is approved by an administrator</span></Bullet>
                    <Bullet><span style={{ color: "#9a9a9a", fontWeight: 300, fontSize: 14 }}>You can then log in and access all features based on your assigned role</span></Bullet>
                </Section>

                <Section>
                    {admins && admins.length > 0 ? (
                        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 10, background: '#f5f5f5', display: 'flex', justifyContent: 'center', border: "1px solid #d9d9d9", marginTop: "28px" }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, justifyContent: "center" }}>
                                <MailOutlined style={{ color: "#1777ff" }} />
                                <div style={{ fontWeight: 400 }}>Need help? Contact an administrator</div>
                            </div>
                            <div style={{ color: '#8c8c8c', fontWeight: 300, textAlign: 'center' }}>
                                {admins.map((a, idx) => (
                                    <div key={a.email || idx} style={{ marginTop: idx === 0 ? 0 : 4 }}>
                                        <a href={`mailto:${a.email}`} style={{ color: '#1677ff' }}>{a.name ? `${a.name} <${a.email}>` : a.email}</a>
                                    </div>
                                ))}
                            </div>
                        </Card>
                    ) : (
                        <HelpBox email={'support@specific.ai'} />
                    )}
                </Section>

                <Section style={{ textAlign: 'center', marginTop: "22px" }}>
                    <Button style={{ width: "100%", height: 43 }} onClick={logout} icon={<LogoutOutlined />}>Log Out</Button>
                </Section>
            </Card>
            <div style={{ textAlign: 'center', color: '#878787', marginTop: 8, fontSize: 12, padding: 5, width: "400px", fontWeight: 300 }}>
                You can close this page and return once you receive the approval email.
            </div>
        </div>
    );
}
